// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "1260px";
var _3 = "1020px";
var _4 = "668px";
var _5 = "1550px";
var _6 = "1140px";
var _7 = "940px";
var _8 = "100%";
var _9 = "15px";
var _a = "620px";
var _b = "#f53535";
var _c = "rgba(0,0,0,.2)";
var _d = "rgba(255,255,255,.38)";
var _e = ".38";
var _f = "rgba(255,255,255,.2)";
var _10 = "#0025ff";
var _11 = "pfx-Waveform-module__fetch-progress--maIVS";
var _12 = "#f60";
var _13 = "#41ead4";
var _14 = "#2cdd78";
var _15 = "#66ab23";
var _16 = "#f5f5f5";
var _17 = "#c3c3c3";
var _18 = "#ececec";
var _19 = "#252525";
var _1a = "#272727";
var _1b = "#c6c6c5";
var _1c = "#333";
var _1d = "#3c3c3c";
var _1e = "#9c9b9b";
var _1f = "#8c8c8c";
var _20 = "#6f6f6e";
var _21 = "#3c3c3b";
var _22 = "#373737";
var _23 = "#6a6a69";
var _24 = "#6f6f6f";
var _25 = "#9f9e9e";
var _26 = "#282828";
var _27 = "#828181";
var _28 = "#1d1d1d";
var _29 = "#979797";
var _2a = "#9c9b9b";
var _2b = "#a7a7a6";
var _2c = "#c6c6c5";
var _2d = "#d8d8d7";
var _2e = "#dddddc";
var _2f = "72px";
var _30 = "40px";
var _31 = "36px";
var _32 = "25px";
var _33 = "18px";
var _34 = "13px";
var _35 = "#0025ff";
var _36 = "rgba(255,255,255,.12)";
var _37 = "#6535f5";
var _38 = "2px";
var _39 = "56px";
var _3a = "56px";
var _3b = "#41ead4";
var _3c = "#f60";
var _3d = "#f83600";
var _3e = "#881f00";
var _3f = "18px";
var _40 = "15px";
var _41 = "pfx-Waveform-module__progress--Q875O";
var _42 = "red";
var _43 = "13px";
var _44 = "rgba(255,255,255,.07)";
var _45 = "#35465c";
var _46 = "#55acee";
var _47 = "pfx-Waveform-module__waveform--pTeCy";
var _48 = "#fff";
var _49 = "#ffce36";
var _4a = "#ffcd00";
var _4b = "red";
export { _1 as "black", _2 as "breakLarge", _3 as "breakMedium", _4 as "breakSmall", _5 as "breakVLarge", _6 as "containerLarge", _7 as "containerMedium", _8 as "containerMobile", _9 as "containerPaddingMobile", _a as "containerSmall", _b as "danger", _c as "darkElement", _d as "disabled", _e as "disabledOpacity", _f as "extraLightElement", _10 as "facebook", _11 as "fetchProgress", _12 as "google", _13 as "green", _14 as "green2", _15 as "greenColor", _16 as "grey1", _17 as "grey10", _18 as "grey2", _19 as "grey25", _1a as "grey27", _1b as "grey3", _1c as "grey33", _1d as "grey3C", _1e as "grey4", _1f as "grey41", _20 as "grey5", _21 as "grey6", _22 as "grey61", _23 as "grey6A", _24 as "grey6F", _25 as "grey7", _26 as "grey8", _27 as "grey82", _28 as "grey9", _29 as "grey97", _2a as "grey9C", _2b as "greyA7", _2c as "greyC6", _2d as "greyD8", _2e as "greyDd", _2f as "header1", _30 as "header2", _31 as "header3", _32 as "header4", _33 as "header5", _34 as "header6", _35 as "klein", _36 as "lightElement", _37 as "lilac", _38 as "menuBorder", _39 as "menuHeight", _3a as "menuMobileHeight", _3b as "ocean", _3c as "orange", _3d as "orange2", _3e as "orangeDark", _3f as "paragraph", _40 as "paragraphSmall", _41 as "progress", _42 as "red", _43 as "subHeaderSmall", _44 as "subtleLightElement", _45 as "tumblr", _46 as "twitter", _47 as "waveform", _48 as "white", _49 as "yellow", _4a as "yellowDeep", _4b as "youtube" }
